import { Box } from '@twilio-paste/core/box';
import { Input } from '@twilio-paste/core/input';
import { Label } from '@twilio-paste/core/label';

import { CopyButton } from '../../../common/CopyButton';


interface CallbackUrlProps {
  label: string;
  url: string;
  infoText?: string;
}

export function CallbackUrl({
  label,
  url,
}: CallbackUrlProps) {
  return (
    <Box marginBottom="space50">
      <Label>
        {label}
      </Label>
      <Box display="flex" columnGap="space40">
        <Box display="flex" columnGap="space20" width="100%">
          <Input type="text" value={url} readOnly />
          <CopyButton title="Copy URL" value={url} />
        </Box>
      </Box>
    </Box>
  );
}
